import React from "react";

export default function Divider({ className = "" }) {
  return (
    <div className={`flex items-center justify-center my-16 ${className}`} aria-hidden>
      <span className="h-px w-16 bg-mizizi-gold/50" />
      <svg width="28" height="28" viewBox="0 0 24 24" className="mx-4 text-mizizi-gold" fill="none" stroke="currentColor" strokeWidth="1.2">
        <path d="M12 2c-2 4-6 5-6 10 0 5 6 10 6 10s6-5 6-10c0-5-4-6-6-10z" />
        <path d="M12 6v16M9 12h6" strokeOpacity="0.5" />
      </svg>
      <span className="h-px w-16 bg-mizizi-gold/50" />
    </div>
  );
}
